import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import DocumentTitle from './components/document-title';

import {
  SUBTYPE_PASSPORT,
  SUBTYPE_ID_CARD,
  SUBTYPE_DRIVER_LIC,
  SUBTYPE_BANK_STATEMENT,
  SUBTYPE_FIXED_SERVICES_BILL,
  SUBTYPE_INTERNET_OR_TV_BILL,
  SUBTYPE_WATER_BILL,
  SUBTYPE_ELECTRICITY_BILL,
  SUBTYPE_GAS_BILL,
  SUBTYPE_SELFIE,
  SUBTYPE_SELFIE_WITH_ID
} from '../../../utils/constants';

import iconDrivingLicense from '../../../assets/svg/driving-license-icon.svg';
import iconIdCard from '../../../assets/svg/id-card-icon.svg';
import iconPassport from '../../../assets/svg/passport-icon.svg';
import DocumentSelectorSC from './document-selector.styled';

const DocumentTypes = {
  [SUBTYPE_ID_CARD]: {
    key: SUBTYPE_ID_CARD,
    icon: iconIdCard,
    text: 'pages:kyc.documents.idCard'
  },
  [SUBTYPE_PASSPORT]: {
    key: SUBTYPE_PASSPORT,
    icon: iconPassport,
    text: 'pages:kyc.documents.passport'
  },
  [SUBTYPE_DRIVER_LIC]: {
    key: SUBTYPE_DRIVER_LIC,
    icon: iconDrivingLicense,
    text: 'pages:kyc.documents.drivingLicense'
  },
  [SUBTYPE_BANK_STATEMENT]: {
    key: SUBTYPE_BANK_STATEMENT,
    // icon: iconDrivingLicense, // TODO: icon
    text: 'pages:kyc.documents.bankStatement'
  },
  [SUBTYPE_FIXED_SERVICES_BILL]: {
    key: SUBTYPE_FIXED_SERVICES_BILL,
    // icon: iconDrivingLicense, // TODO: icon
    text: 'pages:kyc.documents.fixedServicesBill'
  },
  [SUBTYPE_INTERNET_OR_TV_BILL]: {
    key: SUBTYPE_INTERNET_OR_TV_BILL,
    // icon: iconDrivingLicense, // TODO: icon
    text: 'pages:kyc.documents.internetOrTvBill'
  },
  [SUBTYPE_WATER_BILL]: {
    key: SUBTYPE_WATER_BILL,
    // icon: iconDrivingLicense, // TODO: icon
    text: 'pages:kyc.documents.waterBill'
  },
  [SUBTYPE_ELECTRICITY_BILL]: {
    key: SUBTYPE_ELECTRICITY_BILL,
    // icon: iconDrivingLicense, // TODO: icon
    text: 'pages:kyc.documents.electricityBill'
  },
  [SUBTYPE_GAS_BILL]: {
    key: SUBTYPE_GAS_BILL,
    // icon: iconDrivingLicense, // TODO: icon
    text: 'pages:kyc.documents.gasBill'
  },
  [SUBTYPE_SELFIE]: {
    key: SUBTYPE_SELFIE,
    // icon: iconDrivingLicense, // TODO: icon
    text: 'pages:kyc.documents.selfie'
  },
  [SUBTYPE_SELFIE_WITH_ID]: {
    key: SUBTYPE_SELFIE_WITH_ID,
    // icon: iconDrivingLicense, // TODO: icon
    text: 'pages:kyc.documents.selfieWithId'
  }
};

function DocumentSelector({ type, value, onChange, subtypes, errors }) {
  const { t } = useTranslation('components');

  return (
    <DocumentSelectorSC>
      <h6>{t('documentSelector.title')}</h6>
      <div className="document-tiles">
        {Object.entries(subtypes).map(([subtypeKey, subtypeVal]) => {
          return (
            <React.Fragment key={subtypeKey}>
              {type === subtypeVal.type && (
                <DocumentTitle
                  document={
                    DocumentTypes[subtypeKey] || {
                      key: subtypeKey,
                      text: subtypeKey
                    }
                  }
                  onChange={onChange}
                  selected={
                    DocumentTypes[subtypeKey] &&
                    DocumentTypes[subtypeKey].key === value
                      ? true
                      : false
                  }
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
      {errors && errors.length > 0 && (
        <div className="text-error">
          {errors.map(error => (
            <p>{t(error)}</p>
          ))}
        </div>
      )}
    </DocumentSelectorSC>
  );
}

DocumentSelector.propTypes = {
  type: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired
};

export default connect(state => ({ subtypes: state.user.kyc.subtypes }))(
  DocumentSelector
);
